/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-floating-promises */
import {
  Button,
  Col,
  Divider,
  Dropdown,
  InputNumber,
  type MenuProps,
  message,
  Row,
  Space,
  Tooltip,
} from "antd";
import {
  type InstanceLogsTabProps,
  type RequestLogsType,
} from "../../redux/slices/midservice/midserviceTypes";
import { DownOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import Title from "antd/lib/typography/Title";
import Text from "antd/lib/typography/Text";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import {
  deleteLogsAsync,
  requestLogsAsync,
  selectFullMidservice,
} from "../../redux/slices/midservice/midserviceSlice";
import React, { useEffect, useState } from "react";
import { LogsView } from "../../components/LogsView";
import { selectCanUserEdit } from "../../redux/slices/user/userSlice";
import { API } from "../../api/Api";
import { timestampToReadableZone } from "../../utils/time";
message.config({
  maxCount: 1,
});

export const InstanceLogsTab = ({
  logs,
  apiLogs,
}: InstanceLogsTabProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const [logDays, setLogDays] = useState<number>(-1);
  const fullInstance = useAppSelector(selectFullMidservice);
  const canUserEdit = useAppSelector(selectCanUserEdit);
  const [logsTTL, setLogsTTL] = useState(-1);

  const deviceId = React.useMemo(() => {
    const instance = fullInstance?.midserviceInstance;
    if (instance?.deviceId == null) return null;
    return instance.instanceType === "MIDSERVICE"
      ? instance.deviceId.split("-")[0]
      : instance.deviceId;
  }, [fullInstance]);

  useEffect(() => {
    if (deviceId == null) return;
    API.checkLogs(deviceId).then(({ data }) => {
      setLogsTTL(data.ttl);
    });
  }, []);

  const onChange = (value: any): void => {
    setLogDays(value);
    console.log("changed", value);
  };

  const onLogRequestButton = (value: any): void => {
    if (fullInstance?.midserviceInstance?.deviceId == null) return;
    console.log("clicked", value);
    const requestLogsParams: RequestLogsType = {
      domain: fullInstance.midserviceInstance.domain,
      deviceId: fullInstance.midserviceInstance.deviceId,
      days: logDays,
    };
    dispatch(requestLogsAsync(requestLogsParams));
  };

  const onDeleteLogButton = (): void => {
    if (fullInstance?.midserviceInstance?.deviceId == null) return;
    console.log("onDeleteLogButton");
    // const requestLogsParams: DeleteLogsType = {toHost: }
    dispatch(
      deleteLogsAsync({
        domain: fullInstance.midserviceInstance.domain,
        deviceId: fullInstance.midserviceInstance.deviceId,
      }),
    );
  };

  const timePicker: Record<string, number> = {
    // время в секундах
    "1": 60 * 60,
    "2": 2 * 60 * 60,
    "3": 3 * 60 * 60,
    "4": 24 * 60 * 60,
    "5": 2 * 24 * 60 * 60,
    "6": 3 * 24 * 60 * 60,
  };

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (deviceId == null) return;
    API.switchApiLogs(deviceId, timePicker[e.key]).then(({ data }) => {
      const ttl = timestampToReadableZone(data.ttl * 1000);
      setLogsTTL(data.ttl);
      message.success(`Логи включены до ${ttl}`);
    });
  };

  const disableApiLogs = (): void => {
    if (deviceId == null) return;
    API.switchApiLogs(deviceId).then(() => {
      setLogsTTL(-1);
      message.success("Логи отключены");
    });
  };

  const items: MenuProps["items"] = [
    {
      label: "1 час",
      key: "1",
    },
    {
      label: "2 часа",
      key: "2",
    },
    {
      label: "3 часа",
      key: "3",
    },
    {
      label: "1 день",
      key: "4",
    },
    {
      label: "2 дня",
      key: "5",
    },
    {
      label: "3 дня",
      key: "6",
    },
  ];

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <>
      <Title level={5}>Запрос логов</Title>
      <Row wrap={false}>
        <Col flex="auto">
          <Tooltip
            title="Период запроса логов с текушего момента. Если -1, запрос на все логи"
            style={{ margin: "100px" }}
          >
            <QuestionCircleOutlined style={{ margin: 10 }} />
          </Tooltip>
          <InputNumber
            style={{ width: 200 }}
            min={-1}
            placeholder={"Количество дней"}
            onChange={onChange}
          />
        </Col>
        <Col flex="none">
          <Button
            type="primary"
            onClick={onLogRequestButton}
            disabled={!canUserEdit}
          >
            Запросить
          </Button>
        </Col>
      </Row>
      <Divider />
      <Title level={5}>Управление</Title>
      <Row gutter={[8, 8]}>
        <Col>
          <Button
            type="primary"
            danger
            onClick={onDeleteLogButton}
            disabled={!canUserEdit}
          >
            Удалить все логи на устройстве
          </Button>
        </Col>
        <Col>
          {logsTTL > 0 ? (
            <Tooltip
              title={`API-логирование включено до ${timestampToReadableZone(
                logsTTL * 1000,
              )}`}
            >
              <Button
                style={{ backgroundColor: "#fadb14", color: "#000000" }}
                onClick={disableApiLogs}
              >
                <Space>Выключить API-логирование</Space>
              </Button>
            </Tooltip>
          ) : (
            <Dropdown
              menu={menuProps}
              disabled={!canUserEdit}
              trigger={["click"]}
            >
              <Button type="primary">
                <Space>
                  Включить логи запросов в API
                  <DownOutlined />
                </Space>
              </Button>
            </Dropdown>
          )}
        </Col>
      </Row>

      <Divider />
      <Title level={5}>Логи устройства</Title>
      {logs?.length !== undefined && logs?.length > 0 ? (
        <LogsView logs={logs} />
      ) : (
        <Text>Логи отсутствуют</Text>
      )}

      <Divider />
      <Title level={5}>Логи API</Title>
      {apiLogs?.length !== undefined && apiLogs?.length > 0 ? (
        <LogsView logs={apiLogs} />
      ) : (
        <Text>Логи отсутствуют</Text>
      )}
      <div style={{ height: "32px" }} />
    </>
  );
};
